import { render, staticRenderFns } from "./ProductListToolbarSizeSelect.vue?vue&type=template&id=1546b968"
import script from "./ProductListToolbarSizeSelect.vue?vue&type=script&lang=ts"
export * from "./ProductListToolbarSizeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports